import { inject, Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { GsmAbortDialogComponent } from '@app/shared/components/dialog/gsm-abort-dialog/gsm-abort-dialog.component';
import { LowLevelApi } from '@app/shared/services/state/low-level-api.service';
import { ReactiveDialogService } from '@app/shared/services/ui/reactive-dialog.service';
import { ChecklistItemNachbringenComponent } from '@app/views/vertriebscockpit/gsm/checklist-item-nachbringen/checklist-item-nachbringen.component';
import { map, take } from 'rxjs/operators';

// This guard is in place to show a dialog to prompt the users acceptance before leaving a route.

@Injectable({
  providedIn: 'root'
})
export class GsmNachbringenAbortGuard implements CanDeactivate<ChecklistItemNachbringenComponent> {
  private dialogService = inject(ReactiveDialogService);
  private llapi = inject(LowLevelApi);


  nachbringenDialogRefConfig = {
    maxWidth: '1000px',
    data:     {
      title:        'Checkliste Nachbringen verlassen',
      text_pre:     'Wurden eventuell Änderungen vorgenommen, die noch nicht gespeichert wurden? <br /> Bei zurück zur Übersicht gehen nicht gespeicherte Änderungen verloren.',
      buttonConfig: {
        visible:       true,
        actionButtons: [
          {
            name:  'Zurück zur Übersicht',
            color: 'accent'
          },
          {
            name:  'Abbrechen',
            color: 'accent'
          }
        ]
      }
    }
  };

  canDeactivate(component: ChecklistItemNachbringenComponent) {
    if (component.backBtnClicked) {
      return this.dialogService.open(GsmAbortDialogComponent, this.nachbringenDialogRefConfig)
        .afterClosed()
        .pipe(take(1), map(result => {
          if (result && result.status === 'success') {
            this.clearNachbringen();
            return true;
          } else {
            component.backBtnClicked = false;
            return false;
          }
        }));
    } else {
      this.clearNachbringen();
    }
    return true;
  }

  // TODO move nachbringen info to a separate object for more clarity
  private clearNachbringen() {
    this.llapi.resetValues([
      'gsm.schadenNummer',
      'gsm.currentNachbringenFormInput'
    ]);
  }
}
